import * as React from "react";

export function BluePlusIcon(props: any) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="28" height="28" rx="14" fill="#F0F9FF" />
      <path
        d="M14.0001 9.10156V18.9016M9.1001 14.0016H18.9001"
        stroke="#026AA2"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default BluePlusIcon;
